<div
  class="code-editor-wrapper w100"
  [ngClass]="{
    'read-only': readOnly,
    markdown: mode === 'markdown',
    javascript: mode === 'javascript',
    python: mode === 'python',
    debug: mode === 'debug'
  }"
  fxLayout="column"
  fxLayoutAlign="start start"
  (click)="touchEditor()"
>
  @if (showToolbar) {
    <div
      class="toolbar"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      @for (item of toolbarContent; track item) {
        <button
          type="button"
          class="small"
          mat-icon-button
          [attr.color]="item.color"
          [attr.aria-label]="item.aria"
          [matTooltip]="item.tooltip"
          (click)="processToolbarCommand(item.action)"
          [attr.test-id]="item.testId"
          [disabled]="readOnly"
        >
          @if (item.custom) {
            <mat-icon [svgIcon]="item.icon">
            </mat-icon>
          } @else {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
        </button>
      }
    </div>
  }

  @if (showSubToolbar) {
    <div
      class="sub-toolbar"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      @for (item of subToolbarContent; track item) {
        <button
          type="button"
          class="small"
          mat-icon-button
          [attr.color]="item.color"
          [attr.aria-label]="item.aria"
          [matTooltip]="item.tooltip"
          (click)="processToolbarCommand(item.action)"
          [attr.test-id]="item.testId"
          [disabled]="readOnly"
        >
          @if (item.custom) {
            <mat-icon [svgIcon]="item.icon">
            </mat-icon>
          } @else {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
        </button>
      }
    </div>
  }

  <app-ngx-codemirror
    class="code-editor w100"
    [(ngModel)]="content"
    [options]="options"
    (ngModelChange)="handleChange($event)"
    (codeMirrorLoaded)="codeMirrorLoaded($event)"
    [minimumHeight]="minimumHeight()"
    [maximumHeight]="maximumHeight()"
  ></app-ngx-codemirror>
</div>